import { Component, forwardRef, Input } from "@angular/core";
import { AssigneePickerModalService } from "../../modals/assignee-picker/assignee-picker.modal.service";
import { AssignmentDefinition } from "../../assignment.interface";
import { AssigneePickerModalComponent } from "../../modals/assignee-picker/assignee-picker.modal.component";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

@Component({
	selector: "app-assignment-assignees",
	templateUrl: "./assignment-assignees.component.html",
	styleUrl: "./assignment-assignees.component.scss",
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => AssignmentAssigneesComponent),
			multi: true,
		},
	],
})
export class AssignmentAssigneesComponent implements ControlValueAccessor {
	constructor(private assigneePickerModalService: AssigneePickerModalService) {}
	public assignees: DocumentReference[] = [];

	@Input() definition: AssignmentDefinition;
	@Input() v2 = false;

	selectAssignees = async () => {
		const modal = await this.assigneePickerModalService.create(this.assignees, this.definition);
		modal.present();

		const result = await modal.onWillDismiss();

		if (result.role === AssigneePickerModalComponent.save) {
			this.assignees = result.data;
			this.onTouched();
			this.onFormChange(result.data);
		}
	};

	removeAssignee = (assignee: DocumentReference, event?: Event) => {
		event?.stopPropagation();
		this.assignees = this.assignees.filter((x) => x.id !== assignee.id);
		this.onTouched();
		this.onFormChange(this.assignees);
	};

	onFormChange = (_assignees: DocumentReference[]) => {};
	onTouched = () => {};

	disabled = false;

	writeValue(assignees: DocumentReference[]): void {
		this.assignees = assignees || [];
	}

	registerOnChange(fn: (assignees: DocumentReference[]) => void): void {
		this.onFormChange = fn;
	}
	registerOnTouched(fn: () => void): void {
		this.onTouched = fn;
	}
	setDisabledState?(isDisabled: boolean): void {
		this.disabled = isDisabled;
	}
}
